export default __webpack_public_path__ + "static/media/hey-there.69b154e6.gif";